import type { ReactNode } from "react";
import { StarIcon } from "./icons";
import styles from "./Header.module.css";

interface HeaderProps {
  /** Optional right-aligned actions (e.g. the notifications bell). */
  readonly actions?: ReactNode;
}

export function Header({ actions }: Readonly<HeaderProps>) {
  return (
    <div className={styles.header}>
      <div className={styles.headerLogo}>
        <StarIcon />
        <span className={styles.headerTitle}>AiVA</span>
      </div>
      <div className={styles.headerRight}>{actions}</div>
    </div>
  );
}
